import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
import VueToast from "vue-toast-notification";
import "animate.css";
import "vue-toast-notification/dist/theme-sugar.css";
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import Vuelidate from "vuelidate";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import InputRow from "@/components/shared/InputRow";
import TextareaRow from "@/components/shared/TextareaRow";
import RadioRow from "@/components/shared/RadioRow";
import CheckboxRow from "@/components/shared/CheckboxRow";
import FileInput from "@/components/shared/FileInput";
import StaticEditorModal from "@/components/shared/StaticEditorModal.vue";
import txDirective from "@/directives/v-tx";

Vue.config.productionTip = false;

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(VueToast);
Vue.use(VueSlickCarousel);
Vue.use(Vuelidate);

Vue.component("file-input", FileInput);
Vue.component("checkbox-row", CheckboxRow);
Vue.component("radio-row", RadioRow);
Vue.component("input-row", InputRow);
Vue.component("textarea-row", TextareaRow);
Vue.component("static-editor-modal", StaticEditorModal);
Vue.directive("tx", txDirective);

// API base URL is resolved at runtime from the current hostname so the same
// build can serve multiple domains:
//   *.igaplus.de  -> https://api.igaplus.de/api/v1
//   *.aioffice.az -> https://api.aioffice.az/api/v1
//   anything else (dev) -> http://localhost:5000/api/v1
const apiHost =
  typeof window !== "undefined" && window.location
    ? window.location.hostname
    : "";
axios.defaults.baseURL = apiHost.endsWith("igaplus.de")
  ? "https://api.igaplus.de/api/v1"
  : apiHost.endsWith("aioffice.az")
  ? "https://api.aioffice.az/api/v1"
  : "http://localhost:5000/api/v1";

axios.interceptors.response.use(
  (response) => {
    store.commit("setLoader", false);
    return response;
  },
  (error) => {
    const {
      response: { status, data },
    } = error;

    console.log("Error: ", error.response);
    let errMessage = "Xəta baş verdi";

    if (status === 400) {
      if (data && data.data && data.data.errors && data.data.errors.length) {
        errMessage = data.data.errors.join(" ");
      } else if (data && data.ValidationErrors && data.ValidationErrors.length) {
        errMessage = data.ValidationErrors[0].Message;
      } else if (data && data.message) {
        errMessage = data.message;
      }
    }
    if (status === 401) {
      errMessage = "Sessiya bitib, yenidən daxil olun";
      store.dispatch("auth/logout");
      const cur = router.currentRoute.fullPath;
      if (router.currentRoute.name !== "login") {
        router.push({ name: "login", query: { returnUrl: cur } }).catch(() => {});
      }
    }
    if (status === 403) {
      errMessage = (data && data.message) || "İcazə yoxdur";
    }
    if (status === 404) {
      if (data && data.message) {
        errMessage = data.message;
      }
    }
    Vue.$toast.error(errMessage);
    store.commit("setLoader", false);
    return Promise.reject(error);
  }
);

axios.defaults.params = {};
axios.interceptors.request.use(function (config) {
    config.params['culture'] = localStorage.getItem("igaplus-client-language");
    const token = localStorage.getItem("igaplus-client-token");
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}, function (error) {
    return Promise.reject(error);
});

import "./assets/styles/main.scss";

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
